export default "__VITE_ASSET__BEL6fvq0__"